import React, { useState, useEffect } from 'react';
import { AlertTriangle, Lock, Search, AlertCircle, WifiOff, ServerCrash, X } from 'lucide-react';
import { registerErrorHandler } from '../../utils/showError';
import Button from './Button';

const ICON_MAP = {
  AlertTriangle,
  Lock,
  Search,
  AlertCircle,
  WifiOff,
  ServerCrash,
};

const ErrorModal = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    registerErrorHandler(setError);
    return () => registerErrorHandler(null);
  }, []);

  if (!error) return null;

  const { title, message, category, onRetry } = error;
  const IconComponent = ICON_MAP[category?.icon] || AlertCircle;
  const iconColor = category?.color || '#dc2626';

  const handleDismiss = () => setError(null);

  const handleRetry = () => {
    setError(null);
    onRetry?.();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={handleDismiss}
        />

        {/* Modal */}
        <div className="relative bg-white rounded-lg shadow-xl max-w-sm w-full p-6 text-center">
          {/* Close button */}
          <button
            onClick={handleDismiss}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded-md p-1"
          >
            <X size={18} />
          </button>

          {/* Icon */}
          <div
            className="mx-auto flex items-center justify-center w-12 h-12 rounded-full mb-4"
            style={{ backgroundColor: `${iconColor}15` }}
          >
            <IconComponent size={24} style={{ color: iconColor }} />
          </div>

          {/* Title */}
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {title}
          </h3>

          {/* Message */}
          <p className="text-sm text-gray-500 whitespace-pre-line mb-6">
            {message}
          </p>

          {/* Actions */}
          <div className="flex flex-col gap-2">
            {onRetry && (
              <Button variant="primary" onClick={handleRetry} fullWidth>
                Retry
              </Button>
            )}
            <Button variant="secondary" onClick={handleDismiss} fullWidth>
              Dismiss
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
